import type { ElementType, ReactNode } from 'react'

import './legacy-dashboard-sticky-header.css'

interface LegacyDashboardStickyHeaderProps {
  readonly as?: ElementType
  readonly children: ReactNode
  readonly className?: string
  readonly contentClassName?: string
  readonly visible?: boolean
}

function joinClassNames(...classNames: Array<string | undefined | false>) {
  return classNames.filter(Boolean).join(' ')
}

export function LegacyDashboardStickyHeader({
  as: Component = 'div',
  children,
  className,
  contentClassName,
  visible,
}: LegacyDashboardStickyHeaderProps) {
  return (
    <Component
      className={joinClassNames('legacyDashboardStickyHeader', className)}
      data-sticky-visible={
        visible === undefined ? undefined : visible ? 'true' : 'false'
      }
    >
      <div
        className={joinClassNames(
          'legacyDashboardStickyHeaderContent',
          contentClassName,
        )}
      >
        {children}
      </div>
    </Component>
  )
}
